import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Button,
  Box,
  ModalHeader,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  useBreakpointValue,
  Textarea,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Heading,
  Spinner,
  Table,
  Th,
  Thead,
  Tr,
  Tbody,
  Td,
  Grid,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import { AppContext } from "AppProvider/AppContext";
import CommentModal from "../CommentModal/CommentModal";
import { capitalizeCharAndAddSpace } from "components/common/functions/commonFunctions";
import { combineValues } from "../function";
import AddComentModal from "../AddComentModal/AddComentModal";
import CommentDrawer from "../CommentDrawer/CommentDrawer";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  file: any;
  values?: any;
  showValues?: boolean;
  level?: any;
  id?: any;
  getData?: any;
  commentData?: string;
  // handleGetPurchaseOrder: any;
  // setIsItemsOpen: any;
  isManual: boolean;
  isDisabled?: boolean;
  documentId?: any;
  type?: string;
  tagType?: string;
  documentType?: any;
  name?: string;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  handleGet: () => void;
};

export default function ViewerModal({
  isOpen,
  onClose,
  file,
  values,
  showValues,
  type,
  id,
  level,
  getData,
  isManual,
  commentData,
  isDisabled = false,
  documentId,
  tagType,
  documentType,
  name,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  handleGet,
}: ModalProps): JSX.Element {
  const { toastNotify, accountDetails, workFlowData } = useContext(AppContext);
  const [isloading, setIsLoading] = useState(false);
  const [editedValues, setEditedValues] = useState<any>({});
  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [comment, setComment] = useState(commentData!=="-" ? commentData : '');
  const [comment, setComment] = useState("");
  let displayTables = {};

  function transformObject(inputObject: any) {
    const transformedObject: any = {};
    for (const key in inputObject) {
      transformedObject[key] = {
        originalValue: inputObject[key],
        editFieldValue: null,
      };
    }
    return transformedObject;
  }

  if (!Array.isArray(values)) {
    values = transformObject(values?.values || {});
    displayTables = values;
  }

  function getLastValidateObject(arr: any) {
    for (let i = arr.length - 1; i >= 0; i--) {
      if (arr[i] !== null && arr[i] !== undefined) {
        return arr[i];
      }
    }
    return {};
  }

  if (Array.isArray(values) && values?.length) {
    const lastObject = getLastValidateObject(values);
    displayTables = lastObject.values || {};
  }

  const handleValueChange = (key: string, value: string) => {
    setEditedValues((prevFormData: any) => ({
      ...prevFormData,
      [key]: value,
    }));
  };

  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  useEffect(() => {
    if (isOpen) {
      getFile();
    }
  }, [isOpen]);

  const handleCloseCommentModal = () => {
    setIsCommentOpen(false);
  };

  const getFile = async () => {
    try {
      if (file?._id) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            setSample({
              url: fileURL,
              file: file,
              type: file.metadata.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const viewerWidth = useBreakpointValue({ lg: true });

  let width =
    values && showValues && Object.entries(values)?.length > 0
      ? "90vw"
      : "50vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  // updation of document status and comment
  const handleDocUpdate = async (
    status: string,
    level?: any,
    documentId?: any
  ) => {
    try {
      setIsLoading(true);
      let valus = combineValues(values, editedValues);
      console.log(valus);

      // return
      const updatedStatus: any = {};
      updatedStatus["id"] = id;
      updatedStatus["level"] = level;
      updatedStatus["status"] = "approved";
      updatedStatus["comment"] = comment;
      updatedStatus["values"] = valus;
      updatedStatus["type"] = "document";
      const response: any = await appRequest(
        "document",
        "update",
        updatedStatus
      );

      if (response.status === "success") {
        toastNotify({
          title: "Updates submitted",
          message: "Updated successfully.",
        });
        setComment("");
        getData();
        onClose();
      } else {
        toastNotify({
          title: "Error",
          message: "Failed to update document.",
          type: "error",
        });
      }
      // console.log("done");
    } catch (error) {
      toastNotify({
        title: "Error",
        message: "Failed to update document.",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderLabels = (data: any) => {
    const renderAccordionItem = (key: string, value: any) => {
      return (
        <AccordionItem key={key}>
          <h2>
            <AccordionButton>
              <Box flex="1" textAlign="left">
                {capitalizeCharAndAddSpace(key)}
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel>
            {typeof value.originalValue === "object" &&
            value.originalValue !== null ? (
              // If originalValue is an object, recursively call renderLabels
              renderLabels(value.originalValue)
            ) : (
              // If originalValue is not an object, render FormControl
              <FormControl mb="4" variant="floating">
                <Input
                  fontSize="sm"
                  type="text"
                  name={key}
                  color={
                    value?.editFieldValue
                      ? value.editFieldValue !== null
                        ? "red"
                        : ""
                      : ""
                  }
                  value={
                    editedValues.hasOwnProperty(key)
                      ? editedValues[key]
                      : value?.editFieldValue !== null
                      ? value.editFieldValue
                      : JSON.stringify(value.originalValue)
                  }
                  onChange={(e: any) => handleValueChange(key, e.target.value)}
                  isReadOnly={!workFlowData.fileViewer.editable}
                />
                <FormLabel color="gray.700" fontSize="sm">
                  {capitalizeCharAndAddSpace(key)}{" "}
                  {value?.editFieldValue &&
                    value.editFieldValue !== null &&
                    "(edited)"}
                </FormLabel>
              </FormControl>
            )}
          </AccordionPanel>
        </AccordionItem>
      );
    };

    return Object.entries(data).map(([key, value]: [any, any]) => {
      if (
        typeof value?.originalValue === "object" &&
        value?.originalValue !== null
      ) {
        // Render an accordion for objects
        return (
          <Accordion key={key} allowToggle>
            {renderAccordionItem(key, value)}
          </Accordion>
        );
      } else {
        // Render regular FormControl for non-objects
        return (
          <FormControl mb="4" key={key} variant={"floating"}>
            <Input
              fontSize="sm"
              type="text"
              name={key}
              color={
                value?.editFieldValue
                  ? value.editFieldValue !== null
                    ? "red"
                    : ""
                  : ""
              }
              value={
                editedValues.hasOwnProperty(key)
                  ? editedValues[key]
                  : typeof value === "object"
                  ? value?.editFieldValue
                    ? value.editFieldValue
                    : value?.originalValue
                  : JSON.stringify(value)
              }
              onChange={(e: any) => handleValueChange(key, e.target.value)}
              isReadOnly={!workFlowData.fileViewer.editable}
            />
            <FormLabel color="gray.700" fontSize="sm">
              {capitalizeCharAndAddSpace(key)}{" "}
              {value?.editFieldValue &&
                value.editFieldValue !== null &&
                "(edited)"}
            </FormLabel>
          </FormControl>
        );
      }
    });
  };

  console.log("valss", values);

  const renderTable = (data: any) => {
    let { headerGroups = [], rowGroups = [] } = data;

    return (
      <Box overflowY="auto" className="customScrollBar">
        <Table variant="striped" className="drowerTable" size="sm">
          <Thead>
            {headerGroups &&
              headerGroups.map((headers: any, rowIndex: number) => {
                if (Array.isArray(headers)) {
                  console.log("the headers is", headers);
                }
                return (
                  <Tr key={`headerGroup-${rowIndex}`}>
                    {Array.isArray(headers) &&
                      headers.map(
                        (header: any, colIndex: number) =>
                          header && (
                            <Th
                              key={`header-${rowIndex}-${colIndex}`}
                              colSpan={header.columnSpan}
                              rowSpan={header.rowSpan}
                              style={{
                                textAlign: "center",
                                borderRight: "1px solid white",
                                padding: "10px",
                              }}
                              // style={{
                              //   textAlign: "center",
                              //   borderRight: "1px solid white",
                              //   padding: "10px",
                              // }}
                            >
                              {header.content}
                            </Th>
                          )
                      )}
                  </Tr>
                );
              })}
          </Thead>
          <Tbody>
            {rowGroups &&
              rowGroups.map((rows: any, rowIndex: number) => {
                return (
                  <Tr key={`rowsGroup-${rowIndex}`}>
                    {rows &&
                      rows.map((row: any, colIndex: number) => {
                        return (
                          <Td key={`cell-${rowIndex}-${colIndex}`}>
                            {row ? row : row}
                          </Td>
                        );
                      })}
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </Box>
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={viewerWidth ? width : "100vw"}
        animation={`${
          isOpen ? "slideIn" : "slideOut"
        } 0.8s ease-in-out forwards`}
      >
        <ModalHeader
          fontSize={{ base: "md", lg: "lg" }}
          color="teal.300"
          fontWeight="700"
          p=".6rem"
          ml="1rem"
        >
          Document
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          px={{ base: ".5rem", lg: "1.5rem" }}
          py=".2rem"
          overflowY="auto"
          className="customScrollBar"
          mb={{ base: "1rem", lg: "unset" }}
        >
          <Grid
            templateColumns={{ lg: "1fr 1fr" }}
            // display={{ base: "grid", lg: "flex" }}
            // flexDirection={{ base: "column", lg: "row" }}
            gap={{ base: 1, lg: 6 }}
            h="100%"
          >
            {fetchFileLoader ? (
              <Box
                h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                mb="1rem"
                w="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Spinner
                  size="xl"
                  thickness="4px"
                  speed="0.65s"
                  color="teal.400"
                />
              </Box>
            ) : (
              <Box h={{ base: "30vh", md: "40vh", lg: "85vh" }} w="100%">
                <FileViewer sample={sample} />
              </Box>
            )}
            <Box>
              {values && showValues && (
                <Box
                  h={!isDisabled ? "85vh" : "85vh"}
                  w={{ lg: "45vw" }}
                  p={{ base: ".6rem", lg: ".6rem .5rem" }}
                  overflowY="auto"
                  className="customScrollBar"
                  onWheel={handleModalWheel}
                  border="2px solid"
                  borderColor="teal.400"
                  rounded={4}
                >
                  {renderLabels(displayTables)}
                </Box>
              )}
              {/* {!isDisabled && (
                <Box mt="0.5rem">
                  <Input
                    value={comment}
                    placeholder="Add a comment"
                    onChange={handleTextareaChange}
                  />
                </Box>
              )} */}
            </Box>
          </Grid>
        </ModalBody>
        {!isDisabled &&
          accountDetails.role !== "admin" &&
          accountDetails.role === "approver" &&
          name === "Pending Approval" && (
            <ModalFooter p="0.5rem">
              <Button
                isDisabled={isloading}
                onClick={() => {
                  // handleDocUpdate('approved',documentId,level)
                  setCommentModel({
                    open: true,
                    selectedStatus: "approved",
                    comment: "",
                    isMulti: false,
                  });
                }}
                fontSize="sm"
                bg="green.500"
                color="white"
                _hover={{ bg: "green.600" }}
                mr="1rem"
                w="100px"
              >
                Accept
              </Button>
              <Button
                isDisabled={isloading}
                onClick={() =>
                  setCommentModel({
                    open: true,
                    selectedStatus: "rejected",
                    comment: "",
                    isMulti: false,
                  })
                }
                bg="red.500"
                _hover={{ bg: "red.600" }}
                color="white"
                w="100px"
                mr="14px"
              >
                Reject
              </Button>
            </ModalFooter>
          )}
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
      </style>
      <CommentDrawer
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        commentModel={commentModel}
        setCommentModel={setCommentModel}
        handleGet={handleGet}
        view={true}
        isOpen={commentModel.open}
        width={width}
        onClose={handleCloseCommentModal}
        handleClose={onClose}
        editedValues={editedValues}
        selectedFile={file}
      />
    </Modal>
  );
}
